import api from './client';

export const authApi = {
  login: (username, password) => api.post('/auth/login', { username, password }).then((r) => r.data),
  me: () => api.get('/auth/me').then((r) => r.data),
};

export const clientesApi = {
  list: (params) => api.get('/clientes', { params }).then((r) => r.data),
  get: (id) => api.get(`/clientes/${id}`).then((r) => r.data),
  create: (data) => api.post('/clientes', data).then((r) => r.data),
  update: (id, data) => api.put(`/clientes/${id}`, data).then((r) => r.data),
  remove: (id) => api.delete(`/clientes/${id}`).then((r) => r.data),
};

export const empleadosApi = {
  list: (params) => api.get('/empleados', { params }).then((r) => r.data),
  get: (id) => api.get(`/empleados/${id}`).then((r) => r.data),
  create: (data) => api.post('/empleados', data).then((r) => r.data),
  update: (id, data) => api.put(`/empleados/${id}`, data).then((r) => r.data),
  remove: (id) => api.delete(`/empleados/${id}`).then((r) => r.data),
};

export const serviciosApi = {
  list: (params) => api.get('/servicios', { params }).then((r) => r.data),
  get: (id) => api.get(`/servicios/${id}`).then((r) => r.data),
  create: (data) => api.post('/servicios', data).then((r) => r.data),
  update: (id, data) => api.put(`/servicios/${id}`, data).then((r) => r.data),
  remove: (id) => api.delete(`/servicios/${id}`).then((r) => r.data),
};

export const refaccionesApi = {
  list: (params) => api.get('/refacciones', { params }).then((r) => r.data),
  get: (id) => api.get(`/refacciones/${id}`).then((r) => r.data),
  create: (data) => api.post('/refacciones', data).then((r) => r.data),
  update: (id, data) => api.put(`/refacciones/${id}`, data).then((r) => r.data),
  remove: (id) => api.delete(`/refacciones/${id}`).then((r) => r.data),
};

export const relacionesApi = {
  list: (clienteId) => api.get(`/clientes/${clienteId}/relaciones`).then((r) => r.data),
  ultima: (clienteId) => api.get(`/clientes/${clienteId}/relaciones/ultima`).then((r) => r.data),
  get: (clienteId, id) => api.get(`/clientes/${clienteId}/relaciones/${id}`).then((r) => r.data),
  create: (clienteId, data) => api.post(`/clientes/${clienteId}/relaciones`, { ...data, clienteId }).then((r) => r.data),
  update: (clienteId, id, data) => api.put(`/clientes/${clienteId}/relaciones/${id}`, data).then((r) => r.data),
  remove: (clienteId, id) => api.delete(`/clientes/${clienteId}/relaciones/${id}`).then((r) => r.data),
};

export const facturasApi = {
  list: (params) => api.get('/facturas', { params }).then((r) => r.data),
  create: (data) => api.post('/facturas', data).then((r) => r.data),
  remove: (id) => api.delete(`/facturas/${id}`).then((r) => r.data),
};

export const syncApi = {
  pull: (lastSync, clienteId) => api.get('/sync/pull', { params: { lastSync, clienteId } }).then((r) => r.data),
  push: (payload) => api.post('/sync/push', payload).then((r) => r.data),
  status: () => api.get('/sync/status').then((r) => r.data),
};
